<template>
    <div>
        <v-form
            v-model="formValid"
            ref="form"
            @submit="submit"
            style="padding: 0 12px 12px 12px; max-height: 250px; overflow-y: auto"
            class="fci-scrollbar"
        >
            <div style="gap: 10px; display: flex">
                <div style="width: 488px; margin-top: 0!important;">
                    <div class="label">{{ $f.tc("name") }}</div>
                    <v-text-field
                        v-model="model.name"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-text-field>
                </div>
                <div style="width: 488px">
                    <div class="centerY">
                        <div class="label mr-12">{{ $f.tc("campaign") }}</div>
                        <div
                            v-if="!includesCampaign(model.call_campaign_id)"
                            class="mt-2"
                        >
                            {{ model.call_campaign_name }}
                        </div>
                    </div>
                    <div>
                        <v-autocomplete
                            v-model="model.call_campaign_id"
                            :items="updateCampaignList()"
                            item-value="id"
                            item-text="title"
                            :rules="formRules.required"
                            class="input-custom"
                            :disabled="
                            qcCampaign && qcCampaign['number_of_batches'] !== 0
                        "
                        ></v-autocomplete>
                        <v-checkbox
                            v-if="!(qcCampaign && qcCampaign['number_of_batches'] !== 0)"
                            hide-details
                            v-model="saveAsrAudio"
                            style="margin-top: 5px!important;"
                        >
                            <template v-slot:label>
                                <span class="checkbox-custom-label">{{ $f.tc("asrTurnOn") }}</span>
                            </template>
                        </v-checkbox>
                    </div>
                </div>
            </div>
            <div class="label">{{ $f.tc("fileUpload") }}</div>
            <div class="file-upload">
                <v-text-field
                    class="input-custom "
                    :placeholder="$f.tc('chooseFile')"
                    v-model="fileName"
                    @click="pickFile"
                    readonly
                ></v-text-field>
            </div>
            <input
                type="file"
                ref="file"
                v-show="false"
                @change="onFilePicked"
            />
        </v-form>
        <div class="dialog-footer justify-center">
            <div class="btn-primary" @click="submit">
                <div v-if="isSetting">
                    {{ $f.tc("save") }}
                </div>
                <div v-else>
                    {{ $f.tc("next") }}
                    <img
                        class="ml-12"
                        src="/img/arrow-right.svg"
                        alt="icon-next"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import RoleMixin from "@/modules/fptai/mixins/RoleMixin";
import {mapState} from "vuex";
import lodash from "lodash";
import FormFileMixin from "@/modules/fptai/mixins/FormFileMixin";

export default {
    name: "NewQCStep1",
    mixins: [FormMixin, RoleMixin, FormFileMixin],
    props: {
        campaignList: Array,
        isSetting: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            oldDataQCCampaign: null,
            model: {
                call_campaign_id: "",
                call_campaign_name: "",
                name: ""
            },
            fileName: "",
            saveAsrAudio: false,
            chooseCampaignList: [],
        };
    },
    computed: {
        ...mapState({
            isEdit: state => state.campaign.isEdit,
            qcCampaign: state => state.qccampaign.campaign
        })
    },
    methods: {
        clearForm() {
            this.$refs.form.reset();
            this.oldDataQCCampaign = null;
            this.model = {
                call_campaign_id: "",
                call_campaign_name: "",
                name: ""
            };
            this.fileName = "";
        },
        includesCampaign(campaignId) {
            return this.campaignList.find(i => i.id === campaignId);
        },
        createOrUpdateQcCampaign(dontNextStep) {
            this.$appService.dataLoading(true);
            let newCampaign = this.campaignList.find(
                e => e.id === this.model.call_campaign_id
            )?.title;
            if (newCampaign) {
                this.model.call_campaign_name = newCampaign;
            }
            return this.$store
                .dispatch(this.$actionTypes.qccampaign.UPDATE_CAMPAIGN, {
                    campaign: this.qcCampaign,
                    model: this.model
                })
                .then(() => {
                    this.$store.dispatch(
                        this.$actionTypes.qccampaign.DATA_INPUT_SUGGESTION,
                        this.qcCampaign.id
                    );
                    if (!dontNextStep) {
                        this.$emit("nextStep");
                    }
                })
                .finally(() => this.$appService.dataLoading(false));
        },
        submit(event) {
            if (event) {
                event.preventDefault();
            }

            if (!this.formValid) {
                this.$refs.form.validate();
                return;
            }

            if (this.file) {
                if (this.qcCampaign) {
                    this.handleFile();
                } else {
                    this.createOrUpdateQcCampaign(true).then(this.handleFile);
                }
                return;
            }

            const newDataQCCampaign = {
                call_campaign_id: this.model.call_campaign_id,
                name: this.model.name
            };
            if (!lodash.isEqual(newDataQCCampaign, this.oldDataQCCampaign)) {
                this.createOrUpdateQcCampaign();
            } else {
                this.$emit("nextStep");
            }
        },
        handleFile() {
            if (!this.qcCampaign) {
                this.$appService.toastError("Create qc campaign before import");
                return;
            }

            let extFile = this.file.name.split(".").pop();
            if (["json"].includes(extFile)) {
                let formData = new FormData();
                formData.append("file", this.file);
                this.$appService.showLoading();
                this.$http
                    .post(
                        `qc/campaigns/${
                            this.qcCampaign.id
                        }/import-campaign-config/`,
                        formData,
                        {headers: {"Content-Type": "multipart/form-data"}}
                    )
                    .then(() => {
                        this.createOrUpdateQcCampaign();
                        this.$appService.toastSuccess("success");
                    })
                    .catch(err => {
                        this.$appService.toastError(err.toString());
                    })
                    .finally(() => {
                        this.$appService.hideLoading();
                        this.file = null;
                        this.fileName = "";
                        this.$refs.file.value = null;
                    });
            } else {
                this.$appService.toastError(this.$f.tc("invalidFile"));
            }
        },
        updateCampaignList() {
            if (this.saveAsrAudio === true) {
                return this.campaignList.filter(item => item["save_asr_audio"] === true)
            } else {
                return this.campaignList
            }
        },
    },
    watch: {
        qcCampaign: {
            immediate: true,
            deep: true,
            handler: function () {
                if (this.qcCampaign?.id) {
                    this.model.call_campaign_id = this.qcCampaign.call_campaign_id;
                    this.model.call_campaign_name = this.qcCampaign.call_campaign_name;
                    this.model.name = this.qcCampaign.name;
                    this.oldDataQCCampaign = {
                        call_campaign_id: this.model.call_campaign_id,
                        call_campaign_name: this.model.call_campaign_name,
                        name: this.model.name
                    };
                    return;
                }
                this.oldDataQCCampaign = null;
            }
        },
    }
};
</script>
<style scoped lang="scss">
.label {
    margin-top: 10px;
    margin-bottom: 2px;
    font-family: "open sans semi", serif;
    font-size: 13px;
}

.file-upload {
    max-width: 987px;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #ffffff;
            border-radius: 0;
            border: 1px solid #d9d9d9;
            outline: none;
            font-size: 14px;
            padding: 0 10px !important;
            margin: 0;
            display: flex;
            align-items: center;

            &:before,
            &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #ffffff !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.input-custom.v-select {
    ::v-deep {
        .v-input__slot {
            padding: 0 4px 0 10px !important;
        }

        .v-text-field__details {
            right: 32px !important;
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input__control {
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 10px !important;
        top: 11px !important;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}


.checkbox-custom-label {
    font-size: 13px;
    color: black;
    font-family: "open sans", serif;
}
</style>
